
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DocumentInjectedEvidenceUrl, IReplaceParameters } from "../../../../../../../domain/document";
import InjectedObjectEvidencePresentableMixin from "./InjectedObjectEvidencePresentableMixin.vue";

@Component
export default class InjectedObjectEvidenceUrlPresentableMixin extends Mixins(InjectedObjectEvidencePresentableMixin) {
  @Prop()
  source: DocumentInjectedEvidenceUrl;

  @Prop()
  replaceParameters: IReplaceParameters;

  get url(): string {
    const parameters = this.replaceParameters;
    return Object.keys(parameters)
      .reduce((a: string, c: string) => a.replace("{" + c + "}", parameters[c as keyof typeof parameters].toString()), this.source.url);
  }
}
